/**
 * E-post formatering - Fjerner HTML-koder og viser pen tekst
 */

/**
 * Konverter HTML e-post til ren, lesbar tekst
 */
export function htmlToText(html) {
  if (!html) return '';

  // Fjern script og style tags fullstendig
  let text = html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');

  // Konverter vanlige HTML-elementer til tekst
  text = text
    // Linjeskift
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<\/tr>/gi, '\n')
    .replace(/<\/td>/gi, ' | ')

    // Fjern alle andre HTML-tagger
    .replace(/<[^>]+>/g, '')

    // Dekod HTML entities
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")

    // Rydd opp i mellomrom
    .replace(/[ \t]+/g, ' ')  // Flere mellomrom til ett
    .replace(/\n\s+/g, '\n')  // Fjern mellomrom etter linjeskift
    .replace(/\n{3,}/g, '\n\n')  // Maks to linjeskift
    .trim();

  return text;
}

/**
 * Konverter HTML til React JSX med pen formatering
 */
export function renderFormattedEmail(html) {
  if (!html) return <div className="email-empty">Ingen innhold</div>;

  // Først til ren tekst
  const text = htmlToText(html);

  // Del opp i paragrafer
  const paragraphs = text.split('\n\n').filter(p => p.trim());

  return (
    <div className="email-formatted">
      {paragraphs.map((paragraph, index) => {
        // Sjekk om det er en liste
        if (paragraph.includes('\n') && paragraph.split('\n').length > 1) {
          const lines = paragraph.split('\n').filter(l => l.trim());
          return (
            <div key={index} className="email-paragraph">
              {lines.map((line, lineIndex) => (
                <div key={lineIndex} className="email-line">
                  {line}
                </div>
              ))}
            </div>
          );
        }

        // Vanlig paragraf
        return (
          <p key={index} className="email-paragraph">
            {paragraph}
          </p>
        );
      })}
    </div>
  );
}

/**
 * Hent kort forhåndsvisning av e-post (uten HTML)
 */
export function getEmailPreview(html, maxLength = 500) {
  const text = htmlToText(html);
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}
